import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import { getQueryString } from '@/server/utils';
import './scss/index.scss';

export default class purchaseDetails extends React.Component <any, any> {
	constructor(props: any) {
		super(props);
		this.state = {
			id: getQueryString('rid') || '',
			stItemInfoId: getQueryString('id') || '',
			detailsData: '',
		};
	}

	componentDidMount() {
		// 获取页面数据
		this.getDetailsData();

		// 设置推送消息阅读状态
		this.changeStatus();

		// 消除所有推送记录红点
		this.removeRecordPoint();
	}

	render() {
		const { detailsData } = this.state;

		return (
			<div className="page-inquiryDetails">
				<div className="top-adviser">
					<i className="adviser-icon"></i>
					<span className="adviser-text">专属采购顾问：</span>
					<span className="name">{detailsData.stAdminName}&nbsp;&nbsp;{detailsData.stAdminMobile}</span>
				</div>
				<div className="default-card-list">
					<div className="default-card">
						<div className="card-title">
							产品信息
						</div>
						<ul className="card-contetn">
							<li className="card-row">
								<span className="label">产品名称</span>
								<span className="text line-clamp-1">{detailsData.stBreed}</span>
							</li>
							<li className="card-row">
								<span className="label">牌号</span>
								<span className="text line-clamp-1">{detailsData.stGrade}</span>
							</li>
							<li className="card-row">
								<span className="label">规格</span>
								<span className="text line-clamp-1">{detailsData.specification}</span>
							</li>
							<li className="card-row">
								<span className="label">品牌</span>
								<span className="text line-clamp-1">{detailsData.stBrand}</span>
							</li>
							<li className="card-row">
								<span className="label">生产商</span>
								<span className="text line-clamp-1">{detailsData.stFactory}</span>
							</li>
							<li className="card-row">
								<span className="label">数量</span>
								<span className="text line-clamp-1">{detailsData.stNumber} {detailsData.stUnitStr}</span>
							</li>
							<li className="card-row">
								<span className="label">意向价(元)</span>
								<span className="text line-clamp-1">{detailsData.stPrice}</span>
							</li>
							<li className="card-row">
								<span className="label">交货期</span>
								<span className="text line-clamp-1">{detailsData.deliveryDateDesc}</span>
							</li>
							<li className="card-row">
								<span className="label">交货地</span>
								<span className="text line-clamp-1">{detailsData.stArea}</span>
							</li>
							<li className="card-row">
								<span className="label">用途</span>
								<span className="text line-clamp-1">{detailsData.use}</span>
							</li>
							<li className="card-row">
								<span className="label">限时报价</span>
								<span className="text line-clamp-1">{detailsData.quoteStartTimeStr} 至 {detailsData.quoteEndTimeStr}</span>
							</li>
						</ul>
					</div>
					<div className="default-card">
						<div className="card-title">
							买家信息
						</div>
						<ul className="card-contetn">
							<li className="card-row">
								<span className="label">买家公司名称</span>
								<span className="text line-clamp-1">{detailsData.stCompany}</span>
							</li>
							<li className="card-row">
								<span className="label">买家联系人</span>
								<span className="text line-clamp-1">{detailsData.stLinkman}</span>
							</li>
							<li className="card-row">
								<span className="label">买家联系电话</span>
								<span className="text line-clamp-1">{detailsData.stPhone}</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		)
	}

	private async getDetailsData() {
		const r = await request({
			method: "get",
			url: `${config.API}api/member/st/push/wiseShop/details?stItemInfoId=${this.state.stItemInfoId}`,
		})

		if(r.code === 1) {
			
			this.setState({
				detailsData: r.obj,
			})
		}
		 console.log(r, 'r')
	}

	private async changeStatus() {
		await request({
			method: "get",
			url: `${config.API}st/push/wiseShop/look?id=${this.state.id}`,
		});
	}

	private async removeRecordPoint() {
		await request({
			method: "post",
			url: `${config.MALLAPI}api/wshop/ask/remove-ask`,
			data: {
				type: 1,
				recordType: 3,
			}
		});
	}

}